<template>
  <v-btn
    class="app-button"
    :text="text"
    :outlined="outlined"
    :plain="plain"
    :icon="icon"
    :fab="fab"
    :depressed="depressed"
    :rounded="rounded"
    :tile="tile"
    :block="block"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(_, slot) in $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <template v-for="(_, slot) in $slots" #[slot]>
      <slot :name="slot" />
    </template>
  </v-btn>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    text: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    depressed: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    tile: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.app-button {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 400 !important;
  letter-spacing: 0.3px;
  height: 40px !important;
  font-size: 13px !important;
}

.app-button.v-btn--disabled {
  opacity: 1 !important;
}

.app-button.v-btn--disabled {
  opacity: 1 !important;
}

.app-button.v-btn--disabled .v-btn__content {
  opacity: 1 !important;
  color: rgba(0, 0, 0, 0.38) !important;
}

.app-button.v-btn--disabled .v-icon {
  color: rgba(0, 0, 0, 0.38) !important;
}
</style>
